export default __webpack_public_path__ + "static/media/airport.4856d8ed.svg";